import { AssetBanksInterface } from '@app/entities/banks';

export const AssetBanks: AssetBanksInterface = {
  banks: [
    { name: 'RappiCard', installments: [3, 6] },
  ],
  enabled_bank_installments: [3, 6],
  special_bank_installments: [12],
  min_price_banks_exception: {
    default_min_price_banks: 1200,
    bank_items_min_price: 1200,
    bank_items: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    bank_subtitle: 'Todos los bancos: (Min. {{default_min_price_banks}})'
  }
};
